import { useState } from "react";
import styles from "./ArticlesPrintPTagAndQuantityAcknowledge.module.css";
import ErrorAddOn from "../TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";
import { useTranslation } from "@coworker/locales";
import { ItemNoAndTypeWithOrderedDetailsAcknowledge } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { isLoading, Loading } from "../../loading";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { ArticlesPrintPTagAndQuantityAcknowledgeContent } from "./ArticlesPrintPTagAndQuantityAcknowledgeContent/ArticlesPrintPTagAndQuantityAcknowledgeContent";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";
import { ConfirmSheetModal } from "@coworker/apprestructured/src/shared/components/ConfirmSheetModal/ConfirmSheetModal";
import { useItemsWithPieces } from "../../services/useItemsWithPieces";

interface ArticlesPrintPTagAndQuantityAcknowledgeProps {
  title: string;
  subTitle: string;
  disabled?: boolean;
  isError?: boolean;
  itemNosAndTypeWithOrderedDetailsAcknowledge:
    | ItemNoAndTypeWithOrderedDetailsAcknowledge[]
    | null
    | Loading;
  pieces?: boolean;
  pTags?: boolean;
  onAcknowledgeChange: (
    itemNo: string,
    field: "pieces_acknowledge" | "ptags_acknowledge",
    approved: boolean
  ) => void;
  handleConfirm: () => void;
}
export const ArticlesPrintPTagAndQuantityAcknowledge = ({
  title,
  subTitle,
  pieces,
  pTags,
  disabled,
  isError,
  itemNosAndTypeWithOrderedDetailsAcknowledge,
  onAcknowledgeChange,
  handleConfirm,
}: ArticlesPrintPTagAndQuantityAcknowledgeProps) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { t } = useTranslation();
  const { items, isFetchingItems } = useAllAttachedItems(
    itemNosAndTypeWithOrderedDetailsAcknowledge ?? []
  );
  const itemsWithPieces = useItemsWithPieces(
    items,
    itemNosAndTypeWithOrderedDetailsAcknowledge ?? []
  );

  if (
    isLoading(itemNosAndTypeWithOrderedDetailsAcknowledge) ||
    isFetchingItems
  ) {
    return <div>Loading...</div>;
  }

  const handleConfirmWithClose = () => {
    handleConfirm();
    handleCloseModal();
  };

  const itemsAggregates = Array.isArray(
    itemNosAndTypeWithOrderedDetailsAcknowledge
  )
    ? itemNosAndTypeWithOrderedDetailsAcknowledge
    : [];
  const total = (() => {
    if (pieces) {
      return itemsAggregates.reduce(
        (acc, item) => acc + item.pieces_ordered,
        0
      );
    }
    if (pTags) {
      return itemsAggregates.reduce((acc, item) => acc + item.ptags_ordered, 0);
    }
    return 0;
  })();

  const addon = (
    <div className={`${styles["white-box"]} ${styles["addon-container"]}`}>
      <FixaText textStyle="Heading.S" className={styles["addon-text"]}>
        {t("piecesCountString", { count: total })}
      </FixaText>
      <FixaText textStyle="Heading.M" className={styles["addon-chevron"]}>
        ›
      </FixaText>
    </div>
  );

  const emphasised = true;
  return (
    <>
      <FixaListViewItem
        control="navigational"
        controlIcon={null}
        data-testid={`${title}-list-item`}
        title={t(title)}
        onClick={handleOpenModal}
        emphasised={emphasised}
        description={t(subTitle)}
        disabled={disabled}
        addOn={
          isError ? (
            <ErrorAddOn testId="print-ptags-error">
              {t("pleaseFillInString")}
            </ErrorAddOn>
          ) : (
            addon
          )
        }
      />
      <ConfirmSheetModal
        title={t(title)}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirm={handleConfirmWithClose}
        content={
          <div>
            <ArticlesPrintPTagAndQuantityAcknowledgeContent
              items={itemsWithPieces}
              itemNosAndTypeWithOrderedDetails={
                itemNosAndTypeWithOrderedDetailsAcknowledge
              }
              pieces={pieces}
              pTags={pTags}
              onAcknowledgeChange={onAcknowledgeChange}
            />
          </div>
        }
      />
    </>
  );
};
